export enum Brand {
  Nova = 'Nova',
  Axys = 'Axys',
}
